import React from 'react'
import TitleComponent from '../../../../global/Custom/TitleComponent/TitleComponent'

import { useTranslation } from 'react-i18next'
import BannerProductEditScreen from './BannerProductEditScreen'

function BannerProductEdit() {
  const {t} = useTranslation()

  return (
    <div>
        <TitleComponent title={t('Chỉnh sửa sản phẩm')} isExist={false} />
        <BannerProductEditScreen/>
    </div>
  )
}

export default BannerProductEdit
